export default "__VITE_ASSET__BWswvooG__"